import React, { Component } from 'react';
import {
  css
} from 'aphrodite';
import { Link } from 'react-router-dom';
import { Button, Divider } from '@material-ui/core';
import { Controller } from '../../common/Controller';
import { Styles } from './Styles'
import { CommonStyles } from '../../styles/Styles';
import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
import { Breadcrumbs } from '../../components/Breadcrumbs'
import { BreadcrumbsHelper } from '../../helpers/BreadcrumbsHelper';
import { SelectComponentV2 } from '../../components/SelectComponentV2';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import Popover from '@material-ui/core/Popover';
import InputAdornment from '@material-ui/core/InputAdornment';
import MomentUtils from '@date-io/moment';
import momentTz from 'moment-timezone';
import { AppTheme } from '../../styles/AppTheme';
import { MuiPickersUtilsProvider, DateTimePicker } from '@material-ui/pickers';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import { AppConfig } from '../../AppConfig';
import Switch from '@material-ui/core/Switch';
import moment from 'moment';
import { adminData } from '../../data/AdminData.js'
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import { AppHelper } from '../../helpers/AppHelper';
import { DateRangePicker } from './DateRangePicker';
import { MultiCamPicker } from './MultiCamPicker'
import { EventFilter } from './EventFilter'
import { EventRefreshController } from './EventRefreshController'

export class EventActionHeaderbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  renderBackBtn = () => {
    if (this.props.backPathName) {
      return (
        <Link
          to={{ pathname: this.props.backPathName }}
          className={css(Styles.link)}>
          <div className={css(CommonStyles.headerMemberAddContainer, CommonStyles.backButton)} >
            <img src={require('../../assets/images/back-img.svg')} className={css(CommonStyles.addImg)} />
            <p className={css(CommonStyles.margin)}>BACK</p>
          </div>
        </Link>
      )
    }
  }

  render() {
    return (
      <div className={this.props.relativeImageSliderMode ? css(CommonStyles.outerHeaderContainer, Styles.withOpacity) : css(CommonStyles.outerHeaderContainer)}>
        <div className={css(CommonStyles.innerHeaderContainer, CommonStyles.innerHeaderContainerCustom)}>
          <div className={css(CommonStyles.innerHeaderFirstContainer)}>
            {this.renderBackBtn()}

            {(this.props.breadcrumbs || this.props.title) &&
              <div className={css(CommonStyles.headerOrgOuterContainer, Styles.headerOrgOuterContainer)}>
                <p className={css(CommonStyles.headerMemberCountContainer)}>{this.props.title}</p>
                {this.props.breadcrumbs &&
                  <Breadcrumbs items={this.props.breadcrumbs} />
                }
              </div>
            }

            <MultiCamPicker
              place={this.props.place}
              camSelectHandler={this.props.camSelectHandler}
              selectedCamIds={this.props.selectedCamIds}
            />
          </div>

          <DateRangePicker
            timeChangeHandler={this.props.timeChangeHandler}
            fromDateTs={this.props.fromDateTs}
            toDateTs={this.props.toDateTs}
          />

          <div className={css(Styles.headerMemberOuterContainer)}>
            <EventFilter
              filterHandler={this.props.filterHandler}
              place={this.props.place}
            />
            {this.props.eventRefreshHandler &&
              <EventRefreshController
                eventRefreshHandler={this.props.eventRefreshHandler}
              />
            }
          </div>

        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/screens/ClientPlace/EventActionHeaderBar.js